import axios from "axios"
import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { getId, getToken, usePermissions } from "../../user/User"
import BasicTableComponent, { NumberRangeColumnFilter } from "../../components/basic.table"
import { toast } from "react-toastify"

const ProviderList = () => {
    const navigate = useNavigate()

    const { permissions } = usePermissions(getId())
    useEffect(() => {
        if(permissions.client !== undefined && !permissions.client) {
            toast.error("You don't have permission to view providers!")
            navigate("/")
        }
    }, [permissions])

    const handleCreate = async e => {
        e.preventDefault(),
        navigate("/provider/create")
    }

    const columns =  [{
        Header: "Id",
        accessor: "id",
        Filter: NumberRangeColumnFilter,
        filter: 'between'
    }, {
        Header: "Name",
        accessor: "name"
    }, {
        Header: "Edit",
        UrlPart: "provider"
    }, {
        Header: "Delete",
        UrlPart: "provider/delete"
    }]

    const [providers, setProviders] = useState([])

    useEffect(() => {
        axios.get(process.env.REACT_APP_API_URL + "/api/providers", {
            headers: {
                "Authorization": "Bearer " + getToken()
            }
        })
        .then(res => {
            if(res.data === null || res.data === "") {
                return
            }
            setProviders(res.data)
        }).catch(_ => {
            toast.error("Unable to load providers!")
        })
    }, [])

    return (
        <div>
            <button className="btn btn-primary" onClick={handleCreate}>Create provider</button>

            <BasicTableComponent columns={columns} data={providers} />
        </div>
    )
}

export default ProviderList